import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=57573a4e&scoped=true"
import script from "./Salaries.vue?vue&type=script&lang=js"
export * from "./Salaries.vue?vue&type=script&lang=js"
import style0 from "./Salaries.vue?vue&type=style&index=0&id=57573a4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57573a4e",
  null
  
)

export default component.exports